module.exports = __webpack_public_path__ + "static/media/illustration_upgrade-rocket.cd2f53f8.svg";